const isProduction = process.env.NODE_ENV === 'production';

export const BASE_URL = isProduction
  ? 'https://fofog.nl'
  : 'http://localhost:8000';

export const PRODUCTS_URL = '/api/offers';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';